
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductPendrivesGrid1 extends Serenity.EntityGrid<ProductPendrivesRow, any> {
        protected getColumnsKey() { return 'Products.ProductPendrives'; }
        protected getDialogType() { return ProductPendrivesDialog; }
        protected getIdProperty() { return ProductPendrivesRow.idProperty; }
        protected getInsertPermission() { return ProductPendrivesRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductPendrivesRow.localTextPrefix; }
        protected getService() { return ProductPendrivesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            // debugger;
            //this.editItem({ ProductId: this.ProductId });
            this.editItem({ ProductId: this.ProductId, IsTab: true });

        }
        protected getQuickFilters() {

            var filters = super.getQuickFilters();
            filters.splice(Q.indexOf(filters, x => x.field == "ProductId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "PenDriveType"), 1);

            return filters;

        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.ProductId != null;
        }

        private _ProductId: number;

        get ProductId() {
            return this._ProductId;
        }

        set ProductId(value: number) {
            //debugger;
            if (this._ProductId != value) {
                this._ProductId = value;
                this.setEquality(ProductPendrivesRow.Fields.ProductId, value);
                this.refresh();
            }
        }
    }
}